import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import loadable from '@loadable/component';
import useScreen from 'hooks/useScreen';
import PDPAvailableInSizesRow from './PDPAvailableInSizesRow';
import PDPAvailableInSizesListItem from './PDPAvailableInSizesRow/PDPAvailableInSizesListItem';
const AnimateHeight = loadable(() => import('react-animate-height'));
const MOBILE_AND_TABLET_DURATION = 300;
const DESKTOP_DURATION = 500;
const PDPAvailableInSizesUI = t0 => {
  const $ = _c(24);
  const {
    buildYourOwnDetails: t1,
    currentProductId,
    initialIsExpanded: t2,
    loading,
    pdpIsModularBYOProduct: t3,
    products,
    removeUnavailableProductId: t4,
    showBYOSize: t5
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const buildYourOwnDetails = t6;
  const initialIsExpanded = t2 === undefined ? false : t2;
  const pdpIsModularBYOProduct = t3 === undefined ? false : t3;
  const removeUnavailableProductId = t4 === undefined ? _temp : t4;
  const showBYOSize = t5 === undefined ? false : t5;
  const [isExpanded, setIsExpanded] = useState(initialIsExpanded);
  const {
    isMobileOrTablet
  } = useScreen();
  const duration = isMobileOrTablet ? MOBILE_AND_TABLET_DURATION : DESKTOP_DURATION;
  if (loading) {
    let t7;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div className="mb-3 md:mb-6"><Placeholder type="rect" loading={true} style={{
          width: "35%",
          height: 10,
          marginTop: 18
        }} /></div>;
      $[2] = t7;
    } else {
      t7 = $[2];
    }
    return t7;
  }
  if (!products?.length || !currentProductId) {
    let t7;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div />;
      $[3] = t7;
    } else {
      t7 = $[3];
    }
    return t7;
  }
  let t7;
  if ($[4] !== isExpanded) {
    t7 = () => setIsExpanded(!isExpanded);
    $[4] = isExpanded;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const t8 = !pdpIsModularBYOProduct ? `Available in ${products.length} sizes ${isExpanded ? "-" : "+"}` : `Also available in ${products.length} configurations ${isExpanded ? "-" : "+"}`;
  let t9;
  if ($[6] !== t7 || $[7] !== t8) {
    t9 = <div className="inline-block text-sm font-bold text-brand cursor-pointer mt-1 md:mt-0" onClick={t7}>{t8}</div>;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = isExpanded ? "auto" : 0;
  let t11;
  if ($[9] !== currentProductId || $[10] !== products || $[11] !== removeUnavailableProductId) {
    t11 = products.sort(_temp2).map(t12 => {
      const {
        id,
        slug
      } = t12;
      return <PDPAvailableInSizesRow id={id} isActive={id === currentProductId} key={id} pdpProductId={currentProductId} productsData={products} removeUnavailableProductId={removeUnavailableProductId} slug={slug} />;
    });
    $[9] = currentProductId;
    $[10] = products;
    $[11] = removeUnavailableProductId;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== buildYourOwnDetails || $[14] !== showBYOSize) {
    t12 = showBYOSize ? <PDPAvailableInSizesListItem byoCollectionName={buildYourOwnDetails.name} dimensions={buildYourOwnDetails.dimensions || ""} id="byo" image="" isActive={false} isBYO={true} loading={false} name={`Build your own ${buildYourOwnDetails.name}`} price="" urlKey={buildYourOwnDetails.urlKey} /> : null;
    $[13] = buildYourOwnDetails;
    $[14] = showBYOSize;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== duration || $[17] !== t10 || $[18] !== t11 || $[19] !== t12) {
    t13 = <AnimateHeight duration={duration} height={t10}>{t11}{t12}</AnimateHeight>;
    $[16] = duration;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13 || $[22] !== t9) {
    t14 = <div className="mb-3 md:mb-6">{t9}{t13}</div>;
    $[21] = t13;
    $[22] = t9;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
};
PDPAvailableInSizesUI.propTypes = {
  buildYourOwnDetails: PropTypes.shape({
    dimensions: PropTypes.string,
    name: PropTypes.string,
    urlKey: PropTypes.string
  }),
  currentProductId: PropTypes.number,
  initialIsExpanded: PropTypes.bool,
  loading: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  products: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    slug: PropTypes.string
  })),
  removeUnavailableProductId: PropTypes.func,
  showBYOSize: PropTypes.bool
};
export default PDPAvailableInSizesUI;
function _temp() {}
function _temp2(a, b) {
  return a.id - b.id;
}